import { Link } from "react-router-dom";
import { Instagram, Facebook, Music2, MapPin, Phone } from "lucide-react";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/coaching", label: "Coaching" },
  { to: "/coaching", label: "Group Fitness" },
  { to: "/pricing", label: "Pricing" },
  { to: "/awards", label: "Awards" },
  { to: "/coaching", label: "Nutrition" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", url: "https://www.facebook.com/search/top?q=me%201st%20fitness%20red%20deer" },
  { icon: Instagram, label: "Instagram", url: "https://www.instagram.com/me1stfitness" },
  { icon: Music2, label: "TikTok", url: "https://www.tiktok.com/@Fitnessmom43" },
];

const Footer = () => (
  <footer className="relative bg-charcoal grain text-sand" data-testid="footer">
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="inline-block bg-white rounded-2xl px-4 py-2.5 shadow-[0_8px_30px_rgb(0,0,0,0.2)]">
          <img
            src="/logo.png"
            alt="Me 1st Fitness & Coaching logo"
            className="h-16 w-auto"
            data-testid="footer-logo"
          />
        </div>
        <p className="mt-5 font-display text-xl font-semibold text-sage">
          "Put yourself first."
        </p>
        <div className="mt-6 flex gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              data-testid={`footer-social-${s.label.toLowerCase()}`}
              className="w-11 h-11 rounded-full border border-sand/15 flex items-center justify-center text-sand/70 hover:bg-brand hover:text-charcoal hover:border-brand transition-colors duration-300"
            >
              <s.icon size={18} />
            </a>
          ))}
        </div>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-sand/40 mb-5">Explore</p>
        <ul className="space-y-3">
          {QUICK_LINKS.map((l) => (
            <li key={l.label}>
              <Link
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sand/70 hover:text-brand transition-colors duration-200 font-medium"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-sand/40 mb-5">Get in touch</p>
        <div className="space-y-4">
          <p className="flex items-center gap-3 text-sand/70">
            <MapPin size={18} className="text-brand shrink-0" />
            Red Deer, Alberta, Canada
          </p>
          <a
            href="tel:+14035055078"
            data-testid="footer-phone-link"
            className="flex items-center gap-3 text-sand/70 hover:text-sand transition-colors duration-200"
          >
            <Phone size={18} className="text-brand shrink-0" />
            (403) 505-5078
          </a>
        </div>
      </div>
    </div>

    <div className="relative border-t border-sand/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-sand/40">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} Me 1st Fitness &amp; Coaching. All rights reserved.
        </p>
        <p>Group Fitness · Fitness &amp; Nutrition Coaching · Red Deer, AB</p>
      </div>
    </div>
  </footer>
);

export default Footer;
